var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8149 33.6353L13.2392 28.4949C13.5505 27.835 14.4495 27.835 14.7608 28.4949L17.1851 33.6353L22.6067 34.4647C23.3023 34.5711 23.5796 35.4661 23.076 35.9794L19.1536 39.9779L20.0793 45.6266C20.1982 46.3521 19.4706 46.9052 18.8482 46.5626L14 43.8942L9.15178 46.5626C8.52936 46.9052 7.80182 46.3521 7.9207 45.6266L8.84638 39.9779L4.92404 35.9794C4.42043 35.4661 4.69768 34.5711 5.39329 34.4647L10.8149 33.6353Z",
    stroke: "#564418",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8149 33.6353L41.2392 28.4949C41.5505 27.835 42.4495 27.835 42.7608 28.4949L45.1851 33.6353L50.6067 34.4647C51.3023 34.5711 51.5796 35.4661 51.076 35.9794L47.1536 39.9779L48.0793 45.6266C48.1982 46.3521 47.4706 46.9052 46.8482 46.5626L42 43.8942L37.1518 46.5626C36.5294 46.9052 35.8018 46.3521 35.9207 45.6266L36.8464 39.9779L32.924 35.9794C32.4204 35.4661 32.6977 34.5711 33.3933 34.4647L38.8149 33.6353Z",
    stroke: "#564418",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8149 12.6353L27.2392 7.49492C27.5505 6.83503 28.4495 6.83503 28.7608 7.49492L31.1851 12.6353L36.6067 13.4647C37.3023 13.5711 37.5796 14.4661 37.076 14.9794L33.1536 18.9779L34.0793 24.6266C34.1982 25.3521 33.4706 25.9052 32.8482 25.5626L28 22.8942L23.1518 25.5626C22.5294 25.9052 21.8018 25.3521 21.9207 24.6266L22.8464 18.9779L18.924 14.9794C18.4204 14.4661 18.6977 13.5711 19.3933 13.4647L24.8149 12.6353Z",
    stroke: "#564418",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng2);
export default __webpack_public_path__ + "static/media/png2.55bcb610b3873411549e31226ed45ce9.svg";
export { ForwardRef as ReactComponent };